/**
 * Blog posts（Topics）: スライド単位の横スクロール + ドットページャ
 * アクティブドットは「見えているスクロール枠の中心に最も近いスライド」で決定（IO は使わず振動を防ぐ）
 */
(function () {
  function goToPageLabel(i) {
    const tmpl = window.themeVariables?.strings?.goToPageForCarousel;
    return tmpl ? tmpl.replace(/\[NUM\]/g, String(i + 1)) : `Page ${i + 1}`;
  }

  function getScrollEl(inner) {
    if (!inner) {
      return null;
    }
    const wrap = inner.parentElement;
    const wrapDelta = wrap?.classList.contains("scroller") ? wrap.scrollWidth - wrap.clientWidth : 0;
    const innerDelta = inner.scrollWidth - inner.clientWidth;
    if (wrap?.classList.contains("scroller") && wrapDelta > 0 && wrapDelta >= innerDelta) {
      return wrap;
    }
    return inner;
  }

  function setActiveDot(dotsNav, idx) {
    dotsNav.querySelectorAll("button").forEach((btn, i) => {
      btn.setAttribute("aria-current", i === idx ? "true" : "false");
      btn.setAttribute("aria-selected", i === idx ? "true" : "false");
    });
  }

  function scrollToPage(scrollEl, pageEl) {
    if (!scrollEl || !pageEl) {
      return;
    }
    const scrollRect = scrollEl.getBoundingClientRect();
    const pageRect = pageEl.getBoundingClientRect();
    const nextLeft = pageRect.left - scrollRect.left + scrollEl.scrollLeft;
    scrollEl.scrollTo({ left: nextLeft, behavior: "smooth" });
  }

  function buildDotsIfNeeded(dotsNav, pageCount) {
    const existing = dotsNav.querySelectorAll("button").length;
    if (existing === pageCount) {
      return;
    }
    let html = "";
    for (let i = 0; i < pageCount; i++) {
      const label = goToPageLabel(i);
      html += `<button type="button" role="tab" class="dots-nav__item tap-area"${i === 0 ? ' aria-current="true" aria-selected="true"' : ' aria-selected="false"'}><span class="visually-hidden">${label}</span></button>`;
    }
    dotsNav.innerHTML = html;
  }

  function getCenterPageIndex(root, inner) {
    const scrollEl = getScrollEl(inner);
    const pages = root.querySelectorAll("[data-blog-posts-page]");
    if (!scrollEl || !pages.length) {
      return 0;
    }
    const sr = scrollEl.getBoundingClientRect();
    if (sr.width <= 0) {
      return 0;
    }
    const midX = (sr.left + sr.right) / 2;
    let bestI = 0;
    let bestDist = Infinity;
    pages.forEach((page, i) => {
      const pr = page.getBoundingClientRect();
      if (pr.width <= 0) {
        return;
      }
      const pMid = (pr.left + pr.right) / 2;
      const d = Math.abs(pMid - midX);
      if (d < bestDist) {
        bestDist = d;
        bestI = i;
      }
    });
    return bestI;
  }

  function syncPrevNextDisabled(root, inner, pageCount, idx) {
    const wrap = root.querySelector(".product-list__prev-next");
    if (!wrap || pageCount < 2) {
      return;
    }
    const prevBtn = wrap.querySelector(".prev-next-button--prev");
    const nextBtn = wrap.querySelector(".prev-next-button--next");
    const clamped = Math.max(0, Math.min(pageCount - 1, idx));
    if (prevBtn) {
      prevBtn.toggleAttribute("disabled", clamped <= 0);
    }
    if (nextBtn) {
      nextBtn.toggleAttribute("disabled", clamped >= pageCount - 1);
    }
  }

  /** スクロール枠の中心に最も近いページ＝アクティブ（スワイプ中も安定） */
  function updateActiveFromViewportCenter(root, inner, dotsNav) {
    const scrollEl = getScrollEl(inner);
    const pages = root.querySelectorAll("[data-blog-posts-page]");
    const btns = dotsNav.querySelectorAll("button");
    if (!scrollEl || !pages.length || !btns.length) {
      return;
    }
    const bestI = getCenterPageIndex(root, inner);
    setActiveDot(dotsNav, bestI);
    syncPrevNextDisabled(root, inner, pages.length, bestI);
  }

  function bind(root) {
    if (root.dataset.blogPostsCarouselInit) {
      return;
    }
    root.dataset.blogPostsCarouselInit = "true";

    const inner = root.querySelector(".blog-posts__scroller-inner");
    const wrap = inner?.parentElement;
    const dotsNav = root.querySelector("[data-blog-posts-dots]");
    const pagerWrap = root.querySelector("[data-blog-posts-pager-wrap]");
    if (!inner || !dotsNav || !pagerWrap) {
      return;
    }

    let navLockUntil = 0;
    let scrollRaf = 0;

    function isNavLocked() {
      return Date.now() < navLockUntil;
    }

    function runSync() {
      if (!root.isConnected || getComputedStyle(root).display === "none") {
        return;
      }

      const pages = root.querySelectorAll("[data-blog-posts-page]");
      const scrollEl = getScrollEl(inner);
      const pageCount = pages.length;

      if (pageCount <= 1) {
        pagerWrap.setAttribute("hidden", "");
        return;
      }

      pagerWrap.removeAttribute("hidden");
      buildDotsIfNeeded(dotsNav, pageCount);

      if (!scrollEl) {
        return;
      }

      requestAnimationFrame(() => {
        if (!isNavLocked()) {
          updateActiveFromViewportCenter(root, inner, dotsNav);
        }
      });
    }

    const scheduleScrollSync = () => {
      if (scrollRaf) {
        return;
      }
      scrollRaf = requestAnimationFrame(() => {
        scrollRaf = 0;
        if (!isNavLocked()) {
          updateActiveFromViewportCenter(root, inner, dotsNav);
        }
      });
    };

    inner.addEventListener("scroll", scheduleScrollSync, { passive: true });
    if (wrap?.classList.contains("scroller")) {
      wrap.addEventListener("scroll", scheduleScrollSync, { passive: true });
    }

    dotsNav.addEventListener("click", (e) => {
      const btn = e.target.closest("button");
      if (!btn || !dotsNav.contains(btn)) {
        return;
      }
      const pageIndex = Array.prototype.indexOf.call(dotsNav.querySelectorAll("button"), btn);
      if (pageIndex < 0) {
        return;
      }
      const pages = root.querySelectorAll("[data-blog-posts-page]");
      const target = pages[pageIndex];
      if (!target) {
        return;
      }
      navLockUntil = Date.now() + 550;
      setActiveDot(dotsNav, pageIndex);
      const scrollEl = getScrollEl(inner);
      scrollToPage(scrollEl, target);
      syncPrevNextDisabled(root, inner, pages.length, pageIndex);
      setTimeout(() => {
        navLockUntil = 0;
        updateActiveFromViewportCenter(root, inner, dotsNav);
      }, 600);
    });

    root.addEventListener("prev-next:prev", () => {
      const pages = root.querySelectorAll("[data-blog-posts-page]");
      const scrollEl = getScrollEl(inner);
      if (!scrollEl || pages.length < 2 || isNavLocked()) {
        return;
      }
      let idx = getCenterPageIndex(root, inner);
      if (idx <= 0) {
        return;
      }
      idx -= 1;
      navLockUntil = Date.now() + 550;
      setActiveDot(dotsNav, idx);
      scrollToPage(scrollEl, pages[idx]);
      syncPrevNextDisabled(root, inner, pages.length, idx);
      setTimeout(() => {
        navLockUntil = 0;
        updateActiveFromViewportCenter(root, inner, dotsNav);
      }, 600);
    });

    root.addEventListener("prev-next:next", () => {
      const pages = root.querySelectorAll("[data-blog-posts-page]");
      const scrollEl = getScrollEl(inner);
      if (!scrollEl || pages.length < 2 || isNavLocked()) {
        return;
      }
      let idx = getCenterPageIndex(root, inner);
      if (idx >= pages.length - 1) {
        return;
      }
      idx += 1;
      navLockUntil = Date.now() + 550;
      setActiveDot(dotsNav, idx);
      scrollToPage(scrollEl, pages[idx]);
      syncPrevNextDisabled(root, inner, pages.length, idx);
      setTimeout(() => {
        navLockUntil = 0;
        updateActiveFromViewportCenter(root, inner, dotsNav);
      }, 600);
    });

    const ro = new ResizeObserver(runSync);
    ro.observe(inner);
    if (wrap) {
      ro.observe(wrap);
    }

    requestAnimationFrame(runSync);
    setTimeout(runSync, 200);
    setTimeout(runSync, 600);
  }

  function initAll() {
    document.querySelectorAll("[data-blog-posts-carousel]").forEach(bind);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    const root = event.target;
    if (!root?.querySelector?.("[data-blog-posts-carousel]")) {
      return;
    }
    root.querySelectorAll("[data-blog-posts-carousel]").forEach((el) => {
      delete el.dataset.blogPostsCarouselInit;
      bind(el);
    });
  });
})();
